import { render, staticRenderFns } from "./record.vue?vue&type=template&id=0fa46e68&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa46e68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa46e68')) {
      api.createRecord('0fa46e68', component.options)
    } else {
      api.reload('0fa46e68', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=0fa46e68&scoped=true", function () {
      api.rerender('0fa46e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/record.vue"
export default component.exports